var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuToggler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.6665H14V3.99984H2V2.6665ZM2 7.33317H14V8.6665H2V7.33317ZM2 11.9998H14V13.3332H2V11.9998Z",
    fill: "#141921"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuToggler);
export default __webpack_public_path__ + "static/media/menu-toggler.530447357f257d3d8ee5b4a6df602085.svg";
export { ForwardRef as ReactComponent };